import React, { CSSProperties } from 'react';
import { useAppSelector } from '../../store/hooks';
import { getTextClasses } from '../../styles/typography';

interface CTextProps {
  type?: string;
  style?: CSSProperties;
  align?: 'left' | 'center' | 'right' | 'justify';
  color?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

// Alignment classes mapping
const alignClasses: Record<string, string> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
  justify: 'text-justify',
};

const CText: React.FC<CTextProps> = ({
  type = 'r14',
  style,
  align,
  color,
  children,
  className = '',
  onClick,
  ...props
}) => {
  const colors = useAppSelector((state) => state.theme.theme);

  // Get Tailwind classes for typography
  const typeClasses = getTextClasses(type);
  const alignClass = align ? alignClasses[align] : '';

  // Combine all classes
  const combinedClasses = `${typeClasses} ${alignClass} ${className}`.trim();

  return (
    <span
      className={combinedClasses}
      style={{ color: color || colors.textColor, ...style }}
      onClick={onClick}
      {...props}
    >
      {children}
    </span>
  );
};

export default React.memo(CText);
